module.exports = __webpack_public_path__ + "res/dummy_cta2.34660ee2db7e3e6145bcb4985fc14fb0.png";